import { config } from "./config";
import { loadStripe } from "@stripe/stripe-js";

const stripePromise = loadStripe(config.stripeConfig.publicKey);
export default stripePromise;
